import React from 'react';
import { shape, string, number } from 'prop-types';
import { useStyle } from '../../lib/util/classify.js';
import defaultClasses from './ydBannerGroup.module.css';
import YDBannerSlideshow from './templates/YDBannerSlideshow';
//import YDBanner from './ydBanner';
// import YDBannerSolo from './ydBannerSolo';

/**
 * YDBannerGroup component.
 *
 * @typedef YDBannerGroup
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a YD Banner Group.
 */
const YDBannerGroup = props => {
    const { bannergroup } = props;
    const {
        id,
        banners,
        template,
        type,
        slide_effect,
        slide_max_height,
        slide_transition_time,
        slide_pause_duration
    } = bannergroup;

    if (!banners.length) {
        return null;
    }

    const classes = useStyle(defaultClasses, props.classes);

    //TEMPLATE1 = 4 banner output
    //TEMPLATE2 = 1 banner output
    //TEMPLATE3 = 3 banner output
    //TEMPLATE4 = 2 banner output

    let content;
    if (type == 'slideshow') {
        // do slideshow only if there are at least two slides to show
        if (banners.length > 1) {
            content = (
                <YDBannerSlideshow
                    banners={banners}
                    slide_effect={slide_effect}
                    slide_max_height={slide_max_height}
                    slide_transition_time={slide_transition_time}
                    slide_pause_duration={slide_pause_duration}
                />
            );
        } else {
            const TemplateToUse = require('./templates/YDBannerTemplate2')
                .default;
            content = <TemplateToUse banners={banners} classes={classes} />;
        }
    } else {
        const templateName =
            'YDBanner' + template.charAt(0).toUpperCase() + template.slice(1);
        const TemplateToUse = require('./templates/' + templateName).default;

        content = <TemplateToUse banners={banners} classes={classes} />;
    }

    return (
        <div className={classes.bannergroup} key={id}>
            {content}
        </div>
    );
};

/**
 * Props for {@link YDBannerGroup}
 *
 * @typedef props
 *
 * @property {String} content Rich content of the block
 */
/*
 YDBannerGroup.propTypes = {
 item: shape({
 id: number,
 title: string,
 html: string.isRequired
 })
 };
 */

export default YDBannerGroup;
